const getEnvFromQueryString = function(param) {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
        vars[key] = value;
    });
    return vars['env'] && ['prod', 'stage', 'local'].indexOf(vars['env']) !== -1 ? vars['env'] : null;
};

export const Env = () => {
	if (window) {
		if (getEnvFromQueryString()) {
			return getEnvFromQueryString();
		} else if (window.location.href.indexOf('rsvp-stage') !== -1) {
			return 'stage';
		} else if (window.location.href.indexOf('localhost') !== -1) {
			return 'local';
		}
	}
	return 'prod';
};

export default Env;